export enum SignalRMethods {
  ReceiveTransientNotification = "ReceiveTransientNotification",
  ReceiveNonTransientNotification = "ReceiveNonTransientNotification",
  ReceiveNonTransientNotificationCountUpdated = "ReceiveNonTransientNotificationCountUpdated",
  ReceiveShoppingCartUpdatedEvent = "ReceiveShoppingCartUpdatedEvent"
}
